<template>
    <div class="c-image-gallery__item" :key="image.MediaUrl" :class="{ '-full-width' : fullWidth }">
        <div class="c-image-gallery__fig-container" @click="showModal" @keydown.enter="showModal">
            <figure class="c-image-gallery__image-figure">
                <img class="c-image-gallery__image" :src="image.MediaUrl" loading="lazy" :alt="altText" width="300" height="300" />
            </figure>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
    name: 'gallery-image',
    props: {
        image: {
            type: Object,
            required: true,
        },
        productName: {
            type: String,
            default: '',
        },
        index: {
            type: Number,
        },
        fullWidth: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
    	...mapGetters(
    		['getGalleryImagesModalVisible']
		),
        altText() {
            return this.index === 0 ? this.productName : null;
        },
    },
	methods: {
    	...mapMutations(
    		['setGalleryImagesModalVisible', 'setGalleryImagesModalActiveIndex']
		),
		showModal() {
    		const updateGalleryImageModalVisible = !this.getGalleryImagesModalVisible;
    		this.setGalleryImagesModalActiveIndex(this.index);
    		this.setGalleryImagesModalVisible(updateGalleryImageModalVisible);
		}
	}
}
</script>
